import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import TitleBar from './TitleBar';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: '70px',
    textAlign: 'center',
  },
}));

ErrorPage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};

export default function ErrorPage(props) {
  const classes = useStyles();

  return (
    <div>
      <TitleBar />
      <Container className={classes.root} maxWidth="sm">
        <Typography color={'error'}>{props.errorMessage}</Typography>
      </Container>
    </div>
  );
}
